import { render, staticRenderFns } from "./ChannelManager.vue?vue&type=template&id=6c7e5517&scoped=true"
import script from "./ChannelManager.vue?vue&type=script&lang=js"
export * from "./ChannelManager.vue?vue&type=script&lang=js"
import style0 from "./ChannelManager.vue?vue&type=style&index=0&id=6c7e5517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e5517",
  null
  
)

export default component.exports